import React, { Component } from "react";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import { connect } from "react-redux";
import Select from "react-select";
import YearPicker from "react-year-picker";
import { Button, Container, FormGroup, Label } from "reactstrap";
import DropDown from "shared/components/DropDown/index";
import simpleReactValidator from "simple-react-validator";
import { appendCDN } from "../../../utils/dist";
import { fetchFacilityList, fetchGroupList, getReportPdf, getStatusList } from "../../actions/actions";

var dateFormat = require("dateformat");

class ReportP extends Component {
  constructor(props) {
    super(props);
    this.dispatch = this.props.dispatch;
    this.validator = new simpleReactValidator();
    this.datepickerRef = null;
    this.selectAllRef = null;
    this.state = {
      loading: false,
      loadingReport: false,
      isSelectAll: false,
      facilityId: [],
      groupId: "",
      organizationList: [],
      facilityListByOrganization: [],
      selectedStatus: "",
      statusTypes: [],
      selectedYear: new Date().getFullYear(),
      recordNotFound: false,
      recordNotFoundMessage: {},
    };

    this.handleGroupChange = this.handleGroupChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleFacilityChange = this.handleFacilityChange.bind(this);
    this.setDatepickerRef = this.setDatepickerRef.bind(this);
    this.selectAllFacility = this.selectAllFacility.bind(this);
    this.searchForReport = this.searchForReport.bind(this);
    this.handleReportStatusChange = this.handleReportStatusChange.bind(this);
  }

  componentDidMount() {
    appendCDN();

    this.datepickerRef.state.currentYear = new Date().getFullYear();
    this.datepickerRef.state.selectedYear = new Date().getFullYear();

    const { dispatch } = this.props;
    dispatch(fetchGroupList());
    dispatch(getStatusList());
    // dispatch(fetchOccurenceStatusList())
    // debugger
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.group_items !== prevProps.group_items) {
      this.setState(() => {
        return {
          ...prevState,
          organizationList: this.props.group_items,
          loading: false,
        };
      });
    }

    if (this.props.report_status_types !== prevProps.report_status_types) {
      this.setState(() => {
        return {
          ...prevState,
          statusTypes: this.props.report_status_types,
          selectedStatus: 7,
          loading: false,
        };
      });
    }

    if (this.props.facility_data !== prevProps.facility_data) {
      this.setState(() => {
        return {
          ...prevState,
          facilityListByOrganization: this.props.facility_data,
          facilityId: this.props.facility_data.map(({ name, id }) => ({ label: name, value: id })),
          isSelectAll: true,
          loading: false,
        };
      });
    }

    if (this.props.report_pdf_data !== prevProps.report_pdf_data) {
      this.setState(() => {
        return {
          ...prevState,
          recordNotFoundMessage: this.props.report_pdf_data,
          recordNotFound: true,
          loading: false,
        };
      });
    }
  }

  handleGroupChange(event) {
    let groupId = event.target.value;
    this.setState((prevState) => {
      return {
        ...prevState,
        facilityId: [],
        loading: true,
        groupId,
        recordNotFoundMessage: {},
        recordNotFound: false,
      };
    });
    this.dispatch(fetchFacilityList(groupId));
  }

  handleFacilityChange(event) {
    this.setState((prevState) => {
      return {
        ...prevState,
        facilityId: event,
        recordNotFoundMessage: {},
        recordNotFound: false,
      };
    });
  }

  setDatepickerRef(ref) {
    this.datepickerRef = ref;
  }

  selectAllFacility(event) {
    let isAllSelected = event.target.value === "true" ? true : false;

    if (!isAllSelected) {
      this.setState((prevState) => {
        return {
          ...prevState,
          facilityId: this.state.facilityListByOrganization.map(({ name, id }) => ({ label: name, value: id })),
          isSelectAll: !this.state.isSelectAll,
        };
      });
    } else {
      this.setState((prevState) => {
        return {
          ...prevState,
          facilityId: [],
          isSelectAll: !this.state.isSelectAll,
        };
      });
    }
  }

  handleDateChange(date) {
    this.setState((prevState) => {
      return {
        ...prevState,
        selectedYear: date,
        recordNotFoundMessage: {},
        recordNotFound: false,
      };
    });
  }

  validateFormFields(fields = []) {
    var that = this;
    let isValid = true;

    for (let i = 0; i < fields.length; i++) {
      let field = fields[i];
      if (!that.validator.fieldValid(field)) {
        isValid = false;
        break;
      }
    }

    if (!isValid) {
      that.validator.showMessages();
      that.forceUpdate();
    }

    return isValid;
  }

  searchForReport() {
    if (this.validateFormFields(["selected_group", "selected_facility", "status"])) {
      this.setState((prevState) => {
        return {
          ...prevState,
          loading: true,
        };
      });

      let body = {
        org_id: +this.state.groupId,
        contract_facility_id: this.state.facilityId.map(({ value }) => value),
        status: +this.state.selectedStatus,
        year: +this.state.selectedYear,
      };

      this.dispatch(getReportPdf(body)).then((response) => {
        this.setState((prevState) => {
          return {
            ...prevState,
            loading: false,
          };
        });
      });
    }
  }

  handleReportStatusChange(event) {
    let statusId = event.target.value;
    this.setState((prevState) => {
      return {
        ...prevState,
        selectedStatus: statusId,
        recordNotFoundMessage: {},
        recordNotFound: false,
      };
    });
  }

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.loading}>
        <Container fluid={true}>
          <div className="rpt_filter_card">
            <div className="rpt_header_block">
              <h5 className="rpt_heading">Periodical Report</h5>
              <p className="rpt_subheading">Allow single-site, multi-site and group-level reporting.</p>
            </div>
            <div className="rpt_filter_row">
              <div className="rpt_filter_field rpt_field_year">
                <FormGroup className="mb-0">
                  <Label>Year</Label>
                  <YearPicker onChange={this.handleDateChange} ref={this.setDatepickerRef} />
                </FormGroup>
              </div>

              <div className="rpt_filter_field rpt_field_group">
                <FormGroup className="mb-0">
                  <Label>Group</Label>
                  <DropDown name={"selected_group"} data={this.state.organizationList} first_element={"--Select Group--"} onChange={this.handleGroupChange} />
                  <span className="error-text">
                    {this.validator.message("selected_group", this.state.groupId, "required|gt:0", false, {
                      default: "This field is required.",
                    })}
                  </span>
                </FormGroup>
              </div>

              <div className="rpt_filter_field rpt_field_facility">
                <FormGroup className="mb-0">
                  <div className="rpt_facility_label_row">
                    <Label className="mb-0">Facility</Label>
                    {this.state.facilityId.length > 0 && (
                      <span className="rpt_facility_count">{this.state.facilityId.length} selected</span>
                    )}
                  </div>
                  <Select
                    name={"selected_facility"}
                    placeholder="Select facility…"
                    options={this.state.facilityListByOrganization.map(({ name, id }) => ({
                      label: name,
                      value: id,
                    }))}
                    multi
                    value={this.state.facilityId}
                    onChange={this.handleFacilityChange}
                  />
                  <div className="rpt_select_all">
                    <input id="selectAll" type="checkbox" checked={this.state.isSelectAll} value={this.state.isSelectAll} onClick={this.selectAllFacility} />
                    <label htmlFor="selectAll">Select All</label>
                    {this.state.facilityId.length > 0 && (
                      <button
                        type="button"
                        className="rpt_clear_btn"
                        onClick={() => this.setState({ facilityId: [], isSelectAll: false, recordNotFound: false, recordNotFoundMessage: {} })}
                      >
                        Clear
                      </button>
                    )}
                  </div>
                  <span className="error-text">
                    {this.validator.message("selected_facility", this.state.facilityId, "required", false, {
                      default: "This field is required.",
                    })}
                  </span>
                </FormGroup>
              </div>

              <div className="rpt_filter_field rpt_field_status">
                <FormGroup className="mb-0">
                  <Label>Status</Label>
                  <DropDown name={"status"} data={this.state.statusTypes} value={this.state.selectedStatus} onChange={this.handleReportStatusChange} />
                  <span className="error-text">
                    {this.validator.message("status", this.state.selectedStatus, "required|gt:0", false, {
                      default: "This field is required.",
                    })}
                  </span>
                </FormGroup>
              </div>

              <div className="rpt_filter_actions">
                <Button className="btn-apply-report mt-4" disabled={this.state.loading} onClick={this.searchForReport}>
                  {this.state.loading ? "Applying…" : "Apply"}
                </Button>
              </div>
            </div>

            {this.state.recordNotFound && (
              <div className="rpt_filter_footer">
                <span className="rpt_error_msg">{this.state.recordNotFoundMessage.message}</span>
              </div>
            )}
          </div>
        </Container>
      </BlockUi>
    );
  }
}

ReportP.propTypes = {};

function mapStateToProps(state) {
  const {
    postsBySubreddit: { group_items, facility_data, report_status_types, report_pdf_data },
  } = state;

  return { group_items, facility_data, report_status_types, report_pdf_data };
}

const AppContainer = connect(mapStateToProps)(ReportP);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/shared/containers/Reports/index.js